/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { isNull } from '../../helpers';
import { ApiException } from '../../exceptions';
import { ApiEndPointsNames, InitApiType } from '../../types';
import { Bundle } from '../../util';
import { getEndPoints } from '../../config/api/Endpoints';

class Auth0AxiosHelperClass {
  private static readonly instance: AxiosInstance = axios.create();

  async request(apiDomain: ApiEndPointsNames, path: string, init: InitApiType) {
    const result = prepareUrlAndHeaderByType(apiDomain, path, init.pathUrl);
    const options: AxiosRequestConfig = {
      method: 'POST',
      url: result.url,
      withCredentials: init.withCredentials ?? false,
    };
    if (!isNull(init.body)) {
      options.data = init.body;
    }

    if (result.header) {
      options.headers = { ...options.headers, ...result.header };
    }

    return Auth0AxiosHelperClass.instance.request(options);
  }
}

const prepareUrlAndHeaderByType = (
  apiName: ApiEndPointsNames,
  path: string,
  pathUrl?: string | undefined | null,
): any => {
  const config = Bundle.getValue('config');

  if (config.service.environment === 'MOCK') {
    config.channel = 'WEB';
    global.navigator = { userAgent: 'WPDesktop' } as any;
  }

  const lstEndpoints = getEndPoints({
    pEvironment: config.service.environment,
  });
  const endpointFind = lstEndpoints.filter(
    (endPoint) => endPoint.name === apiName,
  );

  if (isNull(endpointFind) || endpointFind.length === 0) {
    throw new ApiException({
      statusCode: '999',
      errorCode: '990',
      errorMessage: 'Endpoint not found',
      message: '',
    });
  }

  let newPath = path;
  if (pathUrl) {
    newPath = pathUrl;
  }

  const { endpoint, type } = endpointFind[0];

  if (endpoint.charAt(endpoint.length - 1) === '/') {
    if (newPath.charAt(0) === '/') {
      newPath = newPath.substring(1);
    }
  } else {
    if (newPath.charAt(0) !== '/') {
      newPath = `/${newPath}`;
    }
  }
  const url = `${endpoint}${newPath}`;
  let header = null;
  if (type === 'Smiles') {
    let channel;
    if (config.channel && config.channel.toUpperCase() === 'WEB') {
      channel = isMobile.any()
        ? 'Mobile'
        : config.channel.charAt(0).toUpperCase() +
          config.channel.toLowerCase().slice(1);
    } else {
      channel = config.channel;
    }

    header = {
      region: config.service.region,
      channel,
    };
  }
  return {
    url,
    header,
    type,
  };
};

const isMobile = {
  any: function () {
    let userAgent = '';
    if (typeof navigator !== 'undefined') {
      userAgent = navigator.userAgent;
    }
    return (
      userAgent.match(/Android/i) ||
      userAgent.match(/BlackBerry/i) ||
      userAgent.match(/iPhone|iPod/i) ||
      userAgent.match(/Opera Mini/i) ||
      userAgent.match(/IEMobile/i) ||
      userAgent.match(/WPDesktop/i)
    );
  },
};

const Auth0AxiosHelper = new Auth0AxiosHelperClass();
export default Auth0AxiosHelper;
